import React from 'react';
import geminiLogo from '../../Gemini_Generated_Image_rvsyaprvsyaprvsy.png';

const Logo = ({ size = 30, showText = true, className = '' }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img 
        src={geminiLogo}
        alt="ZMA Online Logo"
        style={{ 
          width: size, 
          height: size,
          borderRadius: '9px',
          boxShadow: '0 3px 8px var(--primary-glow)'
        }}
      />
      {showText && (
        <span style={{ 
          fontFamily: "'Outfit', sans-serif", 
          fontWeight: 800, 
          fontSize: size * 0.52, 
          color: 'var(--text)' 
        }}>
          ZMA<span style={{ color: 'var(--primary)' }}>Online</span>
        </span>
      )}
    </div>
  );
};

export default Logo;
